module.exports = __webpack_public_path__ + "static/media/logo_codede.7affb28b.png";